import { useMemo } from 'react';
import { Stack } from '@chakra-ui/react';
import MainLayout from 'components/Layout/MainLayout';
import Table from 'pages/SubscriptionUsers/Statistics/components/Table';
import LoadingIndicator from 'components/LoadingIndicator';
import { useGetSubscriptionUsersStatistics } from 'api/subscriptionUsers';
import Search from 'pages/SubscriptionUsers/Statistics/components/Search';
import useQueryParams from 'utils/useQueryParams';

function SubscriptionUsersStatistics() {
  const { queryString } = useQueryParams();

  const {
    isFetching,
    data: { data } = {
      data: [],
    },
  } = useGetSubscriptionUsersStatistics(queryString);

  const statistics = useMemo(() => Object.values(data), [data]);

  return (
    <MainLayout title="Statystyki uczestników" headerButtons={[]}>
      <Stack spacing={4}>
        <Search />
        {isFetching && <LoadingIndicator />}
        {!isFetching && <Table data={statistics || []} />}
      </Stack>
    </MainLayout>
  );
}

export default SubscriptionUsersStatistics;
